import { SxProps, Theme } from '@mui/material'

export const dialogSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: '44.6rem',
}

export const dialogIconSx: SxProps<Theme> = {
  width: '7.4rem',
  height: '7.4rem',
}

export const wrapperSx: SxProps<Theme> = {
  background: (theme) => theme.palette.primary.main,
}
